import { usePolling } from '@/shared/hooks/use-polling';
import { listSessions } from '../api/list-sessions';

export function useSessions() {
  return usePolling(listSessions, 30_000);
}
